module.exports = __webpack_public_path__ + "static/Hassan.0283c1be.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Hassan.jpg
// module id = 936
// module chunks = 3